import { frodoMediaArray } from './frodoMedia'
import { frodoBio } from './frodoBios'
import { hollyProfileReviewHinge, luigiProfileReviewBumble, gatsbyProfileReviewTinder } from './frodoProfileReviews'

export const frodoDatingProfileHinge = {
  _id: 'frodoDatingProfileHingeId',
  userId: 'frodoUserId',
  email: 'frodo@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: frodoMediaArray[7]._id,
      mediaItemURL: frodoMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[7].type,
      caption: frodoMediaArray[7].captions[0],
      subcaption: frodoMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[0]._id,
      mediaItemURL: frodoMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[0].type,
      caption: frodoMediaArray[0].captions[0],
      subcaption: frodoMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[1]._id,
      mediaItemURL: frodoMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[1].type,
      caption: frodoMediaArray[1].captions[0],
      subcaption: frodoMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[3]._id,
      mediaItemURL: frodoMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[3].type,
      caption: frodoMediaArray[3].captions[0],
      subcaption: frodoMediaArray[3].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[4]._id,
      mediaItemURL: frodoMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[4].type,
      caption: frodoMediaArray[4].captions[0],
      subcaption: frodoMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[13]._id,
      mediaItemURL: frodoMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[13].type,
      caption: frodoMediaArray[13].captions[0],
      subcaption: frodoMediaArray[13].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: frodoBio._id,
    vitalInfo: { ...frodoBio.vitalInfo },
    prompts: [
      { ...frodoBio.prompts[0] },
      { ...frodoBio.prompts[1] },
      { ...frodoBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...hollyProfileReviewHinge }
  ],
  mediaItems: [ ...frodoMediaArray ],
  bioItems: { ...frodoBio },
}

export const frodoDatingProfileBumble = {
  _id: 'frodoDatingProfileBumbleId',
  userId: 'frodoUserId',
  email: 'frodo@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: frodoMediaArray[7]._id,
      mediaItemURL: frodoMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[7].type,
      caption: frodoMediaArray[7].captions[0],
      subcaption: frodoMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[0]._id,
      mediaItemURL: frodoMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[0].type,
      caption: frodoMediaArray[0].captions[0],
      subcaption: frodoMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[1]._id,
      mediaItemURL: frodoMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[1].type,
      caption: frodoMediaArray[1].captions[0],
      subcaption: frodoMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[3]._id,
      mediaItemURL: frodoMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[3].type,
      caption: frodoMediaArray[3].captions[0],
      subcaption: frodoMediaArray[3].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[4]._id,
      mediaItemURL: frodoMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[4].type,
      caption: frodoMediaArray[4].captions[0],
      subcaption: frodoMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[13]._id,
      mediaItemURL: frodoMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[13].type,
      caption: frodoMediaArray[13].captions[0],
      subcaption: frodoMediaArray[13].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: frodoBio._id,
    vitalInfo: { ...frodoBio.vitalInfo },
    prompts: [
      { ...frodoBio.prompts[0] },
      { ...frodoBio.prompts[1] },
      { ...frodoBio.prompts[2] }
    ],
    aboutMe: frodoBio.aboutMe[0],
    hobbies: [frodoBio.hobbies[0], frodoBio.hobbies[1], frodoBio.hobbies[2], frodoBio.hobbies[3], frodoBio.hobbies[4] ],
  },
  profileReviews: [
    { ...luigiProfileReviewBumble }
  ],
  mediaItems: [ ...frodoMediaArray ],
  bioItems: { ...frodoBio },
}

export const frodoDatingProfileTinder = {
  _id: 'frodoDatingProfileTinderId',
  userId: 'frodoUserId',
  email: 'frodo@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: frodoMediaArray[7]._id,
      mediaItemURL: frodoMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[7].type,
      caption: frodoMediaArray[7].captions[0],
      subcaption: frodoMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[0]._id,
      mediaItemURL: frodoMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[0].type,
      caption: frodoMediaArray[0].captions[0],
      subcaption: frodoMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[1]._id,
      mediaItemURL: frodoMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[1].type,
      caption: frodoMediaArray[1].captions[0],
      subcaption: frodoMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[3]._id,
      mediaItemURL: frodoMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[3].type,
      caption: frodoMediaArray[3].captions[0],
      subcaption: frodoMediaArray[3].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[4]._id,
      mediaItemURL: frodoMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[4].type,
      caption: frodoMediaArray[4].captions[0],
      subcaption: frodoMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: frodoMediaArray[13]._id,
      mediaItemURL: frodoMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: frodoMediaArray[13].type,
      caption: frodoMediaArray[13].captions[0],
      subcaption: frodoMediaArray[13].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: frodoBio._id,
    vitalInfo: { ...frodoBio.vitalInfo },
    prompts: [
      { ...frodoBio.prompts[0] },
      { ...frodoBio.prompts[1] },
      { ...frodoBio.prompts[2] }
    ],
    aboutMe: frodoBio.aboutMe[0],
    hobbies: [frodoBio.hobbies[0], frodoBio.hobbies[1], frodoBio.hobbies[2], frodoBio.hobbies[3], frodoBio.hobbies[4] ],
  },
  profileReviews: [
    { ...gatsbyProfileReviewTinder }
  ],
  mediaItems: [ ...frodoMediaArray ],
  bioItems: { ...frodoBio },
}